export interface ArticleBlock {
  type: "paragraph" | "image" | "quote" | "heading" | "video";
  text?: string;
  src?: string;
  caption?: string;
}

export interface Article {
  id: string;
  title: string;
  summary: string;
  cover: string;
  category: "news" | "lifestyle" | "trend";
  categoryName: string;
  tags: string[];
  author: string;
  date: string;
  views: number;
  blocks: ArticleBlock[];
}

export interface CategoryMeta {
  key: "news" | "lifestyle" | "trend";
  name: string;
  title: string;
  description: string;
  filterMode: "time" | "tags";
  intro: string;
  cover: string;
}

export const categories: CategoryMeta[] = [
  {
    key: "news",
    name: "品牌动态",
    title: "品牌动态 - 台北娜娜",
    description: "台北娜娜最新品牌动态，涵盖新品发布、联名合作、门店活动与品牌荣誉等官方资讯。",
    filterMode: "time",
    intro: "在这里了解台北娜娜的最新品牌动向，从新品系列、跨界联名到线下的活动与荣誉，第一时间掌握品牌的每一步。",
    cover: "https://readdy.ai/api/search-image?query=minimal%20elegant%20fashion%20brand%20press%20event%20stage%20with%20soft%20neutral%20lighting%2C%20editorial%20photography%2C%20clean%20high%20end%20aesthetic%2C%20warm%20beige%20and%20deep%20navy%20tones&width=1600&height=900&seq=cat-news-2026&orientation=landscape",
  },
  {
    key: "lifestyle",
    name: "生活方式",
    title: "生活方式 - 台北娜娜",
    description: "台北娜娜生活方式频道，分享美食、旅行、健康、居家与穿搭等多元都市生活提案。",
    filterMode: "tags",
    intro: "从一杯手冲咖啡到一场周末小旅行，台北娜娜为你收集都市生活里的美好细节，让品质感融入日常。",
    cover: "https://readdy.ai/api/search-image?query=cozy%20modern%20city%20lifestyle%20scene%20with%20coffee%20and%20greenery%2C%20soft%20natural%20daylight%2C%20warm%20neutral%20palette%2C%20editorial%20interior%20photography&width=1600&height=900&seq=cat-life-2026&orientation=landscape",
  },
  {
    key: "trend",
    name: "潮流趋势",
    title: "潮流趋势 - 台北娜娜",
    description: "台北娜娜潮流趋势频道，带来流行色、材质、风格与配饰等前沿趋势预测与深度解读。",
    filterMode: "tags",
    intro: "流行瞬息万变，我们为你拆解每一季的关键趋势，从色彩、材质到造型，抢先一步看懂下一波潮流。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20fashion%20trend%20runway%20texture%20close%20up%20with%20fabric%20swatches%2C%20moody%20studio%20lighting%2C%20sophisticated%20neutral%20tones%20with%20warm%20accents&width=1600&height=900&seq=cat-trend-2026&orientation=landscape",
  },
];

export const articles: Article[] = [
  {
    id: "n1",
    title: "台北娜娜 2026 秋冬系列于台北时装周盛大发布",
    summary: "以「城市呼吸」为主题，本季系列以利落剪裁与柔和材质，描绘都市人在快节奏中的从容姿态，现场吸引了众多媒体与买手到场。",
    cover: "https://readdy.ai/api/search-image?query=elegant%20fashion%20runway%20show%20with%20model%20in%20tailored%20coat%2C%20soft%20spotlight%2C%20minimal%20deep%20navy%20stage%2C%20high%20end%20editorial%20photography&width=1200&height=800&seq=news-cover-01&orientation=landscape",
    category: "news",
    categoryName: "品牌动态",
    tags: ["新品发布", "时装周"],
    author: "娜娜编辑部",
    date: "2026-10-06",
    views: 12840,
    blocks: [
      { type: "paragraph", text: "10 月 6 日，台北娜娜于台北时装周发布 2026 秋冬系列「城市呼吸」。本季延续品牌对都市生活的观察，以松弛却讲究的轮廓回应快节奏的日常。" },
      { type: "heading", text: "利落剪裁与柔和材质的对话" },
      { type: "paragraph", text: "系列共呈现 42 套造型，以低饱和的深蓝、雾灰与燕麦色为主调，搭配羊绒、精纺羊毛与再生面料，在挺括与柔软之间寻找平衡。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=backstage%20of%20fashion%20show%20with%20garment%20racks%20and%20warm%20lighting%2C%20editorial%20documentary%20style%2C%20neutral%20tones&width=1200&height=800&seq=news-detail-01a&orientation=landscape", caption: "秀场后台：本季系列以低饱和色调贯穿全场" },
      { type: "quote", text: "我们希望衣服能陪人走过一整天，而不是只在一个瞬间好看。——创意总监" },
      { type: "paragraph", text: "发布结束后，品牌同步开启线上预约试穿通道，首批系列单品将于本月底登陆各门店与官网。" },
    ],
  },
  {
    id: "n2",
    title: "台北娜娜携手新锐设计师推出联名限定系列",
    summary: "本次联名以「留白」为灵感，将东方线条与当代廓形结合，推出限量 300 件的限定单品，仅于指定门店与官网发售。",
    cover: "https://readdy.ai/api/search-image?query=two%20minimal%20garments%20on%20hangers%20in%20bright%20studio%2C%20capsule%20collaboration%20fashion%2C%20soft%20neutral%20background%2C%20editorial%20product%20shot&width=1200&height=800&seq=news-cover-02&orientation=landscape",
    category: "news",
    categoryName: "品牌动态",
    tags: ["联名合作", "限定"],
    author: "娜娜编辑部",
    date: "2026-09-22",
    views: 9320,
    blocks: [
      { type: "paragraph", text: "台北娜娜宣布与新锐设计师林知远携手，推出联名限定系列。系列从「留白」这一东方美学出发，用简洁的线条讲述克制的美。" },
      { type: "paragraph", text: "联名系列包含外套、针织与配饰共 9 款单品，全球限量 300 件，每件均附独立编号，极具收藏价值。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=designer%20sketch%20and%20fabric%20swatches%20on%20a%20light%20wooden%20table%2C%20soft%20daylight%2C%20minimal%20editorial%20still%20life&width=1200&height=800&seq=news-detail-02a&orientation=landscape", caption: "设计手稿与面料样本，勾勒联名系列的雏形" },
      { type: "paragraph", text: "限定系列将于 10 月 1 日起在信义旗舰店与品牌官网同步发售，售完即止。" },
    ],
  },
  {
    id: "n3",
    title: "品牌全新旗舰店进驻信义区，打造沉浸式生活空间",
    summary: "占地 320 坪的全新旗舰店融合购物、咖啡与展览功能，以「可漫步的空间」为理念，希望让顾客在此停留更久、体验更多。",
    cover: "https://readdy.ai/api/search-image?query=modern%20flagship%20retail%20store%20interior%20with%20warm%20wood%20and%20stone%20materials%2C%20soft%20ambient%20lighting%2C%20minimal%20high%20end%20design&width=1200&height=800&seq=news-cover-03&orientation=landscape",
    category: "news",
    categoryName: "品牌动态",
    tags: ["门店", "空间"],
    author: "娜娜编辑部",
    date: "2026-09-08",
    views: 7110,
    blocks: [
      { type: "paragraph", text: "台北娜娜全新信义旗舰店正式开幕，占地 320 坪，是品牌迄今规模最大的线下空间。" },
      { type: "paragraph", text: "空间由建筑团队操刀，以「可漫步的空间」为核心理念，将零售、咖啡吧与小型展览区自然串联，让购物成为一次放松的行走。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=spacious%20minimal%20retail%20interior%20with%20large%20windows%20and%20green%20plants%2C%20warm%20daylight%2C%20editorial%20architecture%20photography&width=1200&height=800&seq=news-detail-03a&orientation=landscape", caption: "大面积采光与绿植，让空间充满呼吸感" },
      { type: "paragraph", text: "开幕期间，门店将同步展出品牌十年来的经典设计档案，欢迎到店参观。" },
    ],
  },
  {
    id: "n4",
    title: "台北娜娜获选年度最具影响力时尚品牌",
    summary: "在最新公布的年度时尚产业评选中，台北娜娜凭借稳定的设计语言与可持续实践，入选「年度最具影响力时尚品牌」。",
    cover: "https://readdy.ai/api/search-image?query=elegant%20award%20trophy%20on%20a%20minimal%20podium%20with%20soft%20lighting%2C%20high%20end%20editorial%20still%20life%2C%20neutral%20tones&width=1200&height=800&seq=news-cover-04&orientation=landscape",
    category: "news",
    categoryName: "品牌动态",
    tags: ["荣誉", "可持续"],
    author: "娜娜编辑部",
    date: "2026-08-19",
    views: 6540,
    blocks: [
      { type: "paragraph", text: "在最新公布的年度时尚产业评选中，台北娜娜入选「年度最具影响力时尚品牌」，评审团特别肯定其在可持续面料应用上的长期投入。" },
      { type: "paragraph", text: "过去三年，品牌将再生材质的应用比例提升至 46%，并通过旧衣回收计划，让产品生命周期被进一步延长。" },
      { type: "quote", text: "影响力不是规模，而是你愿意为行业带来什么改变。" },
      { type: "paragraph", text: "未来，品牌将把可持续标准延伸到供应链的每一个环节。" },
    ],
  },
  {
    id: "n5",
    title: "可持续发展计划：品牌推出环保材质胶囊系列",
    summary: "全新胶囊系列采用再生棉与生物基纤维，包装全面改为可降解材质，售价与常规系列持平，让环保不再是溢价选项。",
    cover: "https://readdy.ai/api/search-image?query=sustainable%20fabric%20rolls%20in%20natural%20earthy%20tones%20on%20minimal%20studio%20table%2C%20soft%20natural%20light%2C%20editorial%20textile%20photography&width=1200&height=800&seq=news-cover-05&orientation=landscape",
    category: "news",
    categoryName: "品牌动态",
    tags: ["可持续", "新品发布"],
    author: "娜娜编辑部",
    date: "2026-07-30",
    views: 5210,
    blocks: [
      { type: "paragraph", text: "台北娜娜发布全新环保材质胶囊系列，全部单品采用再生棉、生物基纤维与可降解辅料制作。" },
      { type: "paragraph", text: "品牌同时将全线包装更换为可降解材质，并承诺该系列售价与常规系列持平，让环保成为默认选项而非溢价标签。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=folding%20garments%20made%20of%20natural%20fiber%20with%20kraft%20packaging%2C%20soft%20daylight%2C%20minimal%20editorial%20still%20life&width=1200&height=800&seq=news-detail-05a&orientation=landscape", caption: "可降解包装与天然纤维单品" },
      { type: "paragraph", text: "胶囊系列现已登陆官网与指定门店。" },
    ],
  },
  {
    id: "n6",
    title: "台北娜娜品牌十周年庆典精彩回顾",
    summary: "从一间小店到横跨多城的品牌，十周年之际我们举办了回顾展、限定市集与公益联名，与一路同行的顾客共同庆祝。",
    cover: "https://readdy.ai/api/search-image?query=celebration%20event%20with%20soft%20string%20lights%20and%20elegant%20decor%2C%20warm%20evening%20atmosphere%2C%20editorial%20event%20photography%20neutral%20tones&width=1200&height=800&seq=news-cover-06&orientation=landscape",
    category: "news",
    categoryName: "品牌动态",
    tags: ["活动", "十周年"],
    author: "娜娜编辑部",
    date: "2026-07-11",
    views: 8890,
    blocks: [
      { type: "paragraph", text: "今年夏天，台北娜娜迎来品牌十周年。我们以「十年一刻」为主题，策划了一系列面向公众的庆祝活动。" },
      { type: "paragraph", text: "为期两周的回顾展展出了品牌十年的设计档案、经典单品与幕后故事，现场还设置了限定市集与公益联名专区。" },
      { type: "quote", text: "十年不是终点，而是我们与顾客故事的新起点。" },
      { type: "paragraph", text: "感谢每一位陪伴品牌成长的你，下一个十年，一起继续。" },
    ],
  },
  {
    id: "l1",
    title: "都市慢生活：在台北寻找一杯真正的好咖啡",
    summary: "从巷弄里的小店到河畔的露台，我们走访了五家气质各异的咖啡馆，为你整理出一份适合周末放空的清单。",
    cover: "https://readdy.ai/api/search-image?query=cozy%20specialty%20coffee%20shop%20interior%20with%20pour%20over%20coffee%20on%20wooden%20counter%2C%20warm%20natural%20light%2C%20editorial%20lifestyle%20photography&width=1200&height=800&seq=life-cover-01&orientation=landscape",
    category: "lifestyle",
    categoryName: "生活方式",
    tags: ["咖啡", "美食"],
    author: "林小满",
    date: "2026-10-02",
    views: 7420,
    blocks: [
      { type: "paragraph", text: "慢下来，有时候只需要一杯好咖啡的时间。这一次，我们走进台北的巷弄，寻找那些愿意为一杯手冲花上十分钟的小店。" },
      { type: "heading", text: "把时间交给咖啡师" },
      { type: "paragraph", text: "在这些空间里，点单不是流程的终点。咖啡师会耐心地介绍豆子的产地与风味，让等待本身成为一段值得享受的仪式。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=barista%20carefully%20brewing%20pour%20over%20coffee%2C%20warm%20moody%20lighting%2C%20minimal%20editorial%20photography%20neutral%20tones&width=1200&height=800&seq=life-detail-01a&orientation=landscape", caption: "手冲的温度，是一种对待时间的方式" },
      { type: "paragraph", text: "如果你也想要一个安静的周末，不妨带上这本书，选一家离你最近的店，慢慢坐一个下午。" },
    ],
  },
  {
    id: "l2",
    title: "秋季穿搭指南：三件单品搞定通勤造型",
    summary: "换季衣橱不用大动干戈，一件风衣、一件针织、一条阔腿裤，就能组合出从容又有型的通勤造型。",
    cover: "https://readdy.ai/api/search-image?query=minimal%20autumn%20outfit%20flat%20lay%20with%20trench%20coat%20knit%20and%20trousers%20on%20neutral%20background%2C%20soft%20daylight%2C%20editorial%20fashion%20still%20life&width=1200&height=800&seq=life-cover-02&orientation=landscape",
    category: "lifestyle",
    categoryName: "生活方式",
    tags: ["穿搭", "通勤"],
    author: "陈之遥",
    date: "2026-09-25",
    views: 6180,
    blocks: [
      { type: "paragraph", text: "秋天是最考验搭配功力的季节，早晚凉、中午热。与其添置一堆单品，不如把基础款穿出层次。" },
      { type: "heading", text: "三件单品，无限组合" },
      { type: "paragraph", text: "一件色调温和的风衣负责外套，一件细针织打底保持轻薄，一条高腰阔腿裤拉长比例。三者之间随意叠穿，就能应对一周的通勤。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=woman%20in%20neutral%20autumn%20coat%20walking%20in%20city%20street%2C%20soft%20daylight%2C%20editorial%20street%20style%20photography%20muted%20tones&width=1200&height=800&seq=life-detail-02a&orientation=landscape", caption: "低饱和配色，让通勤造型更显高级" },
      { type: "paragraph", text: "记住，颜色不超过三种，材质有一处对比，造型就不会出错。" },
    ],
  },
  {
    id: "l3",
    title: "健康生活提案：从一个从容的晨间仪式开始",
    summary: "真正的健康不靠突击，而靠每天的小习惯。我们从呼吸、饮水与早餐开始，聊聊如何让清晨更值得期待。",
    cover: "https://readdy.ai/api/search-image?query=bright%20morning%20breakfast%20table%20with%20fruits%20and%20water%20glass%20near%20window%2C%20soft%20sunlight%2C%20minimal%20healthy%20editorial%20photography&width=1200&height=800&seq=life-cover-03&orientation=landscape",
    category: "lifestyle",
    categoryName: "生活方式",
    tags: ["健康", "居家"],
    author: "苏念",
    date: "2026-09-14",
    views: 4930,
    blocks: [
      { type: "paragraph", text: "被闹钟叫醒的早晨总是兵荒马乱。试着把第一个闹钟提前十五分钟，用它来照顾自己，而不是赶路。" },
      { type: "paragraph", text: "一杯温水、几次深呼吸、一份简单的早餐，这些微小的动作会在日积月累中改变一整天的状态。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=calm%20morning%20routine%20with%20yoga%20mat%20and%20warm%20tea%20by%20a%20sunny%20window%2C%20serene%20minimal%20interior%2C%20soft%20neutral%20tones&width=1200&height=800&seq=life-detail-03a&orientation=landscape", caption: "给自己十五分钟，让清晨慢下来" },
      { type: "paragraph", text: "健康不是一场冲刺，而是一种被温柔对待的日常。" },
    ],
  },
  {
    id: "l4",
    title: "周末小旅行：北海岸的一日轻旅路线",
    summary: "不必远行，台北近郊就有一条适合当天往返的路线：海景公路、老车站与一间面海的咖啡馆，足够治愈一个周末。",
    cover: "https://readdy.ai/api/search-image?query=coastal%20road%20trip%20by%20the%20sea%20with%20clear%20blue%20sky%20and%20winding%20road%2C%20soft%20afternoon%20light%2C%20editorial%20travel%20photography%20muted%20tones&width=1200&height=800&seq=life-cover-04&orientation=landscape",
    category: "lifestyle",
    categoryName: "生活方式",
    tags: ["旅行", "户外"],
    author: "周予安",
    date: "2026-08-29",
    views: 5670,
    blocks: [
      { type: "paragraph", text: "如果只有一个周末，那就把它交给北海岸。开车沿着海景公路一路向北，风景会替你把杂念清空。" },
      { type: "paragraph", text: "路线不必复杂：先到老车站拍几张照片，再找一间面海的咖啡馆坐坐，日落前赶到渔港吃一顿新鲜的海产。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=seaside%20cafe%20terrace%20overlooking%20the%20ocean%20at%20sunset%2C%20warm%20golden%20light%2C%20editorial%20travel%20photography&width=1200&height=800&seq=life-detail-04a&orientation=landscape", caption: "面海的露台，是这条路线最好的句点" },
      { type: "paragraph", text: "轻装出发，把时间留给路上。" },
    ],
  },
  {
    id: "l5",
    title: "居家美学：用香氛打造一个疗愈的空间",
    summary: "气味是最容易被忽略的居家元素。选对一支香氛，就能让回到家这件事，多一分被接纳的松弛感。",
    cover: "https://readdy.ai/api/search-image?query=minimal%20home%20interior%20with%20scented%20candle%20and%20diffuser%20on%20wooden%20shelf%2C%20warm%20soft%20lighting%2C%20editorial%20interior%20photography%20neutral%20tones&width=1200&height=800&seq=life-cover-05&orientation=landscape",
    category: "lifestyle",
    categoryName: "生活方式",
    tags: ["居家", "美学"],
    author: "苏念",
    date: "2026-08-16",
    views: 4380,
    blocks: [
      { type: "paragraph", text: "我们常常花心思挑选家具和灯光，却很少认真对待家里的味道。其实气味，才是空间里最先被记住的部分。" },
      { type: "paragraph", text: "客厅适合清爽的木质调，卧室可以选择温暖的琥珀与香草，玄关则用一支清新的柑橙迎接每一个归家的人。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=relaxing%20home%20corner%20with%20candle%20books%20and%20soft%20blanket%2C%20cozy%20evening%20lighting%2C%20minimal%20editorial%20interior%20photo&width=1200&height=800&seq=life-detail-05a&orientation=landscape", caption: "一支香氛，让家的轮廓更清晰" },
      { type: "paragraph", text: "不需要很贵的香氛，适合你的气味，就是最好的气味。" },
    ],
  },
  {
    id: "l6",
    title: "美食地图：藏在巷弄里的私房料理",
    summary: "没有招牌、不做宣传，却总是座无虚席。我们探访了三家藏在巷弄里的私房料理，记录下老板们的坚持与手艺。",
    cover: "https://readdy.ai/api/search-image?query=rustic%20taiwanese%20home%20style%20dishes%20on%20a%20table%2C%20warm%20ambient%20lighting%2C%20editorial%20food%20photography%20neutral%20earthy%20tones&width=1200&height=800&seq=life-cover-06&orientation=landscape",
    category: "lifestyle",
    categoryName: "生活方式",
    tags: ["美食", "探店"],
    author: "林小满",
    date: "2026-08-03",
    views: 6910,
    blocks: [
      { type: "paragraph", text: "真正的美味往往不在地图上。它们藏在巷弄的尽头，靠一张熟客的口碑活着。" },
      { type: "paragraph", text: "我们拜访的三家私房料理，各有各的固执：有的只做当季食材，有的坚持手工慢炖，有的每天只营业四小时。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=chef%20plating%20a%20seasonal%20dish%20in%20a%20small%20kitchen%2C%20warm%20focused%20lighting%2C%20documentary%20editorial%20food%20photography&width=1200&height=800&seq=life-detail-06a&orientation=landscape", caption: "手艺人的专注，是私房料理的底色" },
      { type: "paragraph", text: "下次路过那条巷子，别急着走过去，也许里面正藏着一顿惊喜。" },
    ],
  },
  {
    id: "t1",
    title: "2026 秋冬流行色趋势预测：低饱和主导，暖色点睛",
    summary: "本季色彩趋向克制与静气，深蓝、雾灰与燕麦色成为主旋律，而一抹温暖的橘调则承担起提亮整体造型的关键角色。",
    cover: "https://readdy.ai/api/search-image?query=color%20palette%20swatches%20of%20deep%20navy%20grey%20oat%20and%20warm%20orange%20on%20minimal%20surface%2C%20soft%20studio%20lighting%2C%20editorial%20design%20photography&width=1200&height=800&seq=trend-cover-01&orientation=landscape",
    category: "trend",
    categoryName: "潮流趋势",
    tags: ["色彩", "趋势预测"],
    author: "趋势研究室",
    date: "2026-10-08",
    views: 10420,
    blocks: [
      { type: "paragraph", text: "如果说上一季是张扬的，那么 2026 秋冬则明显安静下来。主色调转向低饱和的深蓝、雾灰与燕麦色，营造出沉稳而有质感的氛围。" },
      { type: "heading", text: "让一抹橘色成为焦点" },
      { type: "paragraph", text: "在整体克制的基调中，暖橘色被反复用于围巾、包袋与鞋履等点睛单品。它不喧宾夺主，却能让整套造型立刻活起来。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=outfit%20with%20muted%20navy%20coat%20and%20orange%20accessories%20styled%20on%20neutral%20background%2C%20editorial%20fashion%20photography%20soft%20light&width=1200&height=800&seq=trend-detail-01a&orientation=landscape", caption: "低饱和基调 + 暖色配件，是本季配色公式" },
      { type: "paragraph", text: "把握住「大面积克制，小面积点睛」的原则，你就能轻松穿出高级感。" },
    ],
  },
  {
    id: "t2",
    title: "复古回潮：千禧风格的当代表达",
    summary: "低腰、亮面与撞色再次回到视野，但这一次的复古不再是简单复刻，而是以更精致的材质与剪裁重新诠释。",
    cover: "https://readdy.ai/api/search-image?query=y2k%20inspired%20modern%20outfit%20with%20sheen%20fabric%20and%20bold%20silhouette%20on%20minimal%20backdrop%2C%20editorial%20fashion%20photography%20muted%20tones&width=1200&height=800&seq=trend-cover-02&orientation=landscape",
    category: "trend",
    categoryName: "潮流趋势",
    tags: ["风格", "复古"],
    author: "趋势研究室",
    date: "2026-09-18",
    views: 8760,
    blocks: [
      { type: "paragraph", text: "千禧风格从社交平台一路火回秀场。低腰裤、亮面材质与高饱和撞色重新出现，勾起了许多人的青春记忆。" },
      { type: "paragraph", text: "但这一次的复古并非简单复刻。设计师们用更考究的面料与更利落的剪裁，让怀旧元素变得可以日常穿着。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=studio%20portrait%20of%20model%20in%20modern%20retro%20outfit%20with%20statement%20accessories%2C%20dramatic%20soft%20lighting%2C%20editorial%20fashion%20photography&width=1200&height=800&seq=trend-detail-02a&orientation=landscape", caption: "怀旧元素，被重新裁剪成当下的样子" },
      { type: "paragraph", text: "想要入门？从一件亮面外套或一条低腰裤开始尝试就好。" },
    ],
  },
  {
    id: "t3",
    title: "材质趋势：可持续面料正在成为主流",
    summary: "再生尼龙、生物基纤维与天然染整，正从「环保标签」变成设计师的常规选择。这一季，材质本身成为设计的语言。",
    cover: "https://readdy.ai/api/search-image?query=close%20up%20of%20sustainable%20textile%20fibers%20in%20natural%20tones%20with%20visible%20texture%2C%20soft%20studio%20light%2C%20editorial%20material%20photography&width=1200&height=800&seq=trend-cover-03&orientation=landscape",
    category: "trend",
    categoryName: "潮流趋势",
    tags: ["材质", "可持续"],
    author: "趋势研究室",
    date: "2026-09-01",
    views: 6890,
    blocks: [
      { type: "paragraph", text: "过去，可持续面料常常意味着更高的价格与更少的款式选择。但这一季，情况正在改变。" },
      { type: "paragraph", text: "再生尼龙、生物基纤维与天然染整工艺，越来越频繁地出现在主流设计系列中，材质本身成为品牌表达态度的方式。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=stack%20of%20textured%20natural%20fabrics%20in%20earth%20tones%2C%20soft%20directional%20light%2C%20minimal%20editorial%20textile%20photography&width=1200&height=800&seq=trend-detail-03a&orientation=landscape", caption: "材质的肌理，正在成为新的设计焦点" },
      { type: "paragraph", text: "对消费者而言，选择可持续面料，不再是一种妥协，而是一种更聪明的时尚。" },
    ],
  },
  {
    id: "t4",
    title: "街头与高级时装的边界，正在消失",
    summary: "运动廓形、机能细节与高级剪裁彼此渗透，时装与街头的界限越来越模糊，混搭成为当下的主流穿着方式。",
    cover: "https://readdy.ai/api/search-image?query=street%20style%20meets%20high%20fashion%20outfit%20with%20technical%20details%20on%20urban%20background%2C%20editorial%20photography%20muted%20tones%20soft%20light&width=1200&height=800&seq=trend-cover-04&orientation=landscape",
    category: "trend",
    categoryName: "潮流趋势",
    tags: ["风格", "混搭"],
    author: "趋势研究室",
    date: "2026-08-21",
    views: 5980,
    blocks: [
      { type: "paragraph", text: "曾经泾渭分明的街头与时装，如今正在同一件衣服上相遇。运动廓形遇上精工剪裁，机能细节出现在正装外套上。" },
      { type: "paragraph", text: "这种融合让穿衣变得更自由：你不再需要为场合选择一种风格，而可以用混搭表达自己的态度。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=urban%20editorial%20portrait%20mixing%20sportswear%20and%20tailoring%2C%20concrete%20city%20backdrop%2C%20soft%20neutral%20lighting%2C%20fashion%20photography&width=1200&height=800&seq=trend-detail-04a&orientation=landscape", caption: "混搭，是当下最诚实的自我表达" },
      { type: "paragraph", text: "关键不在于单品有多贵，而在于你敢不敢把它们放到一起。" },
    ],
  },
  {
    id: "t5",
    title: "配饰趋势：大廓形包袋强势回归",
    summary: "能装、耐看、有态度，大廓形包袋成为本季最实用的投资单品。体积感与柔软线条的结合，是它的核心魅力。",
    cover: "https://readdy.ai/api/search-image?query=oversized%20soft%20leather%20bag%20styled%20on%20a%20minimal%20surface%2C%20warm%20soft%20lighting%2C%20editorial%20accessory%20product%20photography%20neutral%20tones&width=1200&height=800&seq=trend-cover-05&orientation=landscape",
    category: "trend",
    categoryName: "潮流趋势",
    tags: ["配饰", "包袋"],
    author: "趋势研究室",
    date: "2026-08-07",
    views: 5210,
    blocks: [
      { type: "paragraph", text: "小包的时代似乎告一段落，本季秀场与街头同时被大廓形包袋占据。它们柔软、随性，却极有存在感。" },
      { type: "paragraph", text: "无论是通勤还是出街，一只大包都能装下你一天的所需，也让整体造型的轮廓更有分量。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=model%20holding%20a%20large%20slouchy%20leather%20bag%20while%20walking%2C%20soft%20daylight%2C%20editorial%20street%20style%20photography%20muted%20palette&width=1200&height=800&seq=trend-detail-05a&orientation=landscape", caption: "体积感与柔软线条，是它的魅力所在" },
      { type: "paragraph", text: "选一只颜色沉稳、材质扎实的大包，它至少能陪你走过好几个季节。" },
    ],
  },
  {
    id: "t6",
    title: "数字时尚：虚拟衣柜正在崛起",
    summary: "当服装以数字形式存在，试穿、收藏与分享都在屏幕中完成。数字时尚正悄然改变我们与衣服相处的方式。",
    cover: "https://readdy.ai/api/search-image?query=futuristic%20digital%20fashion%20concept%20with%20holographic%20garment%20on%20minimal%20gradient%20background%2C%20editorial%20editorial%20render%20aesthetic%20muted%20tones&width=1200&height=800&seq=trend-cover-06&orientation=landscape",
    category: "trend",
    categoryName: "潮流趋势",
    tags: ["数字时尚", "科技"],
    author: "趋势研究室",
    date: "2026-07-24",
    views: 4380,
    blocks: [
      { type: "paragraph", text: "越来越多品牌开始发布只能存在于屏幕里的服装。它们不占用衣柜空间，却能被无限次穿着与分享。" },
      { type: "paragraph", text: "数字时尚不仅是一种营销方式，也在重新定义「拥有」这件事——你收藏的可能不是一个物件，而是一种表达。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=virtual%20fitting%20interface%20displaying%20digital%20garments%2C%20soft%20glowing%20screen%20light%2C%20minimal%20tech%20editorial%20aesthetic&width=1200&height=800&seq=trend-detail-06a&orientation=landscape", caption: "虚拟试衣，让时尚有了新的边界" },
      { type: "paragraph", text: "它未必会取代实体服装，但一定会成为时尚世界里越来越重要的一部分。" },
    ],
  },
];

export const heroSlides = [
  {
    id: "n1",
    title: "2026 秋冬系列「城市呼吸」盛大发布",
    description: "以利落剪裁与柔和材质，描绘都市人在快节奏中的从容姿态。",
    image: "https://readdy.ai/api/search-image?query=elegant%20fashion%20runway%20scene%20with%20model%20in%20tailored%20coat%20under%20soft%20spotlight%2C%20minimal%20deep%20navy%20stage%2C%20high%20end%20editorial%20photography%2C%20cinematic&width=1920&height=900&seq=hero-slide-01&orientation=landscape",
    tag: "品牌动态",
  },
  {
    id: "t1",
    title: "2026 秋冬流行色：低饱和主导，暖色点睛",
    description: "深蓝、雾灰与燕麦色成为主旋律，一抹温暖橘调提亮全身。",
    image: "https://readdy.ai/api/search-image?query=editorial%20still%20life%20of%20color%20palette%20swatches%20deep%20navy%20grey%20oat%20and%20warm%20orange%2C%20soft%20studio%20lighting%2C%20minimal%20sophisticated%20aesthetic&width=1920&height=900&seq=hero-slide-02&orientation=landscape",
    tag: "潮流趋势",
  },
  {
    id: "l1",
    title: "都市慢生活：在台北寻找一杯好咖啡",
    description: "走访五家气质各异的咖啡馆，整理出一份适合周末放空的清单。",
    image: "https://readdy.ai/api/search-image?query=cozy%20specialty%20coffee%20shop%20interior%20with%20warm%20natural%20light%20and%20wooden%20counter%2C%20cinematic%20editorial%20lifestyle%20photography%20neutral%20tones&width=1920&height=900&seq=hero-slide-03&orientation=landscape",
    tag: "生活方式",
  },
  {
    id: "n3",
    title: "全新旗舰店进驻信义区，打造沉浸式生活空间",
    description: "融合购物、咖啡与展览，让停留本身成为一次放松的行走。",
    image: "https://readdy.ai/api/search-image?query=modern%20flagship%20retail%20store%20interior%20with%20warm%20wood%20and%20stone%20materials%2C%20soft%20ambient%20lighting%2C%20minimal%20high%20end%20architecture%20photography&width=1920&height=900&seq=hero-slide-04&orientation=landscape",
    tag: "品牌动态",
  },
];

export const topics = [
  {
    id: "tp1",
    title: "低饱和美学专题",
    description: "从色彩、材质到搭配，系统解读这一季最值得关注的克制美学。",
    image: "https://readdy.ai/api/search-image?query=minimal%20moodboard%20of%20muted%20tones%20fabrics%20and%20swatches%20in%20soft%20daylight%2C%20editorial%20design%20photography%20neutral%20palette&width=800&height=1000&seq=topic-01&orientation=portrait",
  },
  {
    id: "tp2",
    title: "城市漫游计划",
    description: "用脚步丈量城市，发现藏在日常里的美好生活提案。",
    image: "https://readdy.ai/api/search-image?query=city%20walking%20lifestyle%20scene%20with%20person%20strolling%20quiet%20street%2C%20soft%20afternoon%20light%2C%20editorial%20travel%20photography%20muted%20tones&width=800&height=1000&seq=topic-02&orientation=portrait",
  },
  {
    id: "tp3",
    title: "可持续时尚观察",
    description: "追踪环保面料与循环设计，看见时尚产业的绿色转向。",
    image: "https://readdy.ai/api/search-image?query=sustainable%20fashion%20concept%20with%20natural%20textiles%20and%20green%20leaves%2C%20soft%20daylight%2C%20minimal%20editorial%20photography%20earthy%20tones&width=800&height=1000&seq=topic-03&orientation=portrait",
  },
  {
    id: "tp4",
    title: "千禧回潮档案",
    description: "梳理复古元素的当代表达，看懂 Y2K 风格的再次流行。",
    image: "https://readdy.ai/api/search-image?query=y2k%20inspired%20fashion%20still%20life%20with%20sheen%20fabric%20and%20statement%20accessories%2C%20studio%20lighting%2C%20editorial%20photography%20muted%20tones&width=800&height=1000&seq=topic-04&orientation=portrait",
  },
];